const { complete, hover, signatureHelp } = require("./lua-analyzer/analyze.js");
const { getLibraryFiles, storageEntriesToLua } = require("./lua-lib-loader.js");

const module = angular.module("monaco", []);

const session = {
    eventType: "MessageEvent",
    storageLua: "",
};

function kindOf(monaco, kind) {
    if (kind === "function") return monaco.languages.CompletionItemKind.Function;
    if (kind === "field") return monaco.languages.CompletionItemKind.Field;
    if (kind === "class") return monaco.languages.CompletionItemKind.Class;
    return monaco.languages.CompletionItemKind.Variable;
}

function queryFor(model, position) {
    return {
        files: [
            { name: "user.lua", text: model.getValue() },
        ].concat(getLibraryFiles(session.eventType, session.storageLua)),
        file: "user.lua",
        line: position.lineNumber,
        column: position.column,
    };
}

function registerLuaProviders() {
    const monaco = window.monaco;
    if (!monaco || monaco.__bahabotLua) return;
    monaco.__bahabotLua = true;

    monaco.languages.registerCompletionItemProvider("lua", {
        triggerCharacters: [".", ":"],
        provideCompletionItems: function (model, position) {
            const word = model.getWordUntilPosition(position);
            const range = {
                startLineNumber: position.lineNumber,
                startColumn: word.startColumn,
                endLineNumber: position.lineNumber,
                endColumn: word.endColumn,
            };
            const result = complete(queryFor(model, position));
            return {
                suggestions: (result.items || []).map(function (item) {
                    return {
                        label: item.label,
                        kind: kindOf(monaco, item.kind),
                        insertText: item.insertText || item.label,
                        documentation: item.documentation || item.detail || "",
                        detail: item.detail || "",
                        range: range,
                    };
                }),
            };
        },
    });

    monaco.languages.registerHoverProvider("lua", {
        provideHover: function (model, position) {
            const h = hover(queryFor(model, position));
            if (!h || !h.contents || !h.contents.length) return null;
            return {
                contents: h.contents.map(function (c) {
                    return { value: "```lua\n" + c + "\n```" };
                }),
            };
        },
    });

    monaco.languages.registerSignatureHelpProvider("lua", {
        signatureHelpTriggerCharacters: ["(", ","],
        provideSignatureHelp: function (model, position) {
            const sig = signatureHelp(queryFor(model, position));
            if (!sig.signatures || !sig.signatures.length) return null;
            return {
                value: {
                    signatures: sig.signatures.map(function (s) {
                        return {
                            label: s.label,
                            parameters: (s.parameters || []).map(function (p) {
                                return { label: p.label };
                            }),
                        };
                    }),
                    activeSignature: 0,
                    activeParameter: sig.activeParameter || 0,
                },
                dispose: function () {},
            };
        },
    });
}

module.directive("monacoEditor", ["$http", function ($http) {
    registerLuaProviders();

    return {
        restrict: "A",
        scope: {
            code: "=",
            language: "@",
            readonly: "<?",
            eventType: "=?",
            onInit: "&?",
        },
        link: function (scope, element) {
            const container = element[0];
            const editor = window.monaco.editor.create(container, {
                value: scope.code || "",
                language: scope.language || "lua",
                theme: "vs-dark",
                readOnly: !!scope.readonly,
                automaticLayout: true,
                minimap: { enabled: true },
                quickSuggestions: true,
                snippetSuggestions: "inline",
                acceptSuggestionOnEnter: "off",
                parameterHints: { enabled: true },
            });

            const model = editor.getModel();

            model.onDidChangeContent(function () {
                scope.$applyAsync(function () {
                    scope.code = model.getValue();
                });
            });

            scope.$watch("code", function (newVal) {
                if (model.getValue() !== newVal) {
                    model.setValue(newVal || "");
                }
            });

            scope.$watch("eventType", function (ty) {
                if (ty) session.eventType = ty;
            });

            $http.get("/api/protected/storage").then(function (res) {
                const rows = (res.data && res.data.data) || res.data || [];
                session.storageLua = storageEntriesToLua(rows);
            }).catch(function () {
                session.storageLua = "";
            });

            if (scope.onInit) {
                editor.layout();
                scope.onInit({ editor: editor });
            }

            const onResize = function () {
                editor.layout();
            };
            window.addEventListener("resize", onResize);

            scope.$on("$destroy", function () {
                editor.dispose();
                window.removeEventListener("resize", onResize);
            });
        },
    };
}]);
